import {
  WhereaboutsCheckApiFactory,
  WhereaboutsCheckStatusResponse,
} from '@/repository/manager/whereaboutsCheck/openapi/generated';
import { AxiosInstance } from 'axios';
import { ErrorPresenter } from '@/repository/errorPresenter/types';

export default function (axios: AxiosInstance) {
  const api = WhereaboutsCheckApiFactory(undefined, `${process.env.MANAGER_API_URL}`, axios);
  return (errorPresenter: ErrorPresenter): WhereaboutsCheckStatusRepository =>
    async () => {
      try {
        const { data } = await api.getWhereaboutsCheckStatus();
        return adapt(data);
      } catch (e) {
        errorPresenter({ status: e.response?.status, error: e, requestUrl: e.config?.url });
        throw e;
      }
    };
}

const adapt = (data: WhereaboutsCheckStatusResponse): WhereaboutsCheckStatus => {
  return {
    isOutage: data.isOutage,
    isOutageParentNotification: data.isOutageParentNotification,
    isDeliveryLimitExceeded: data.isDeliveryLimitExceeded,
    serviceStatus: data.status,
    lastUpdatedAt: new Date(data.lastUpdatedAt),
    latestVersion: data.latestVersion,
    secondsUntilNextUpdate: data.secondsUntilNextUpdate,
  };
};
